import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { COMPONENTS } from './index';

import { UEditorConfig } from './ueditor.config';

import { ScriptService } from './script.service';

@NgModule({
  declarations: [...COMPONENTS],
  imports: [CommonModule],
  exports: [...COMPONENTS],
  providers: [ScriptService],
})
export class UEditorModule {
  static forRoot(config: UEditorConfig): ModuleWithProviders {
    return {
      ngModule: UEditorModule,
      providers: [
        { provide: UEditorConfig, useValue: config }
      ]
    };
  }
}
